// import { Common } from "@/helper/common";
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  computed: {
    ...mapGetters({
      formData: "getFormData",
      contactId: "getContactId",
      mainContactId: "getMainContactId",
      additionalContactId: "getAdditionalContactId",
      jwtToken: "getJwtToken",
      isMainUserGBGVerified: "isMainUserGBGVerified",
      isAdditionalUserGBGVerified: "isAdditionalUserGBGVerified",
    }),
    isGBGVerified() {
      if (this.isMainUserGBGVerified) {
        if (this.additionalContactId != null) {
          if (this.isAdditionalUserGBGVerified) return true;
          else return false;
        } else return true;
      } else return false;
    },
  },
  methods: {
    resetMessageInfo() {
      this.$store.dispatch("setMessageInfo", {
        show: false,
        message: "",
        isSuccess: false,
      });
    },
    showGenericErrorMessage(message, success) {
      this.$store.dispatch("setMessageInfo", {
        show: true,
        message: message,
        isSuccess: success,
      });
    },
    async createContact() {
      const payload = {
        titleId: parseInt(this.formData.title),
        firstName: this.formData.firstName,
        lastName: this.formData.lastName,
        email: this.formData.email,
        dateOfBirth: this.formData.dob,
        telNumber: this.formData.telPrefix + this.formData.telephone,
        mobileNumber: this.formData.mobilePrefix + this.formData.mobile,
        address:
          parseInt(this.formData.country.CountryId) == 5
            ? ""
            : this.formData.addressLine,
        buildingNameNo: this.formData.buildingNo,
        postCode: this.formData.postCode,
        city: this.formData.city,
        countryId:
          this.formData.country.CRMCountryId != null
            ? parseInt(this.formData.country.CRMCountryId)
            : 0,
        postcodeAnywhereId: this.formData.postcodeAnywhereId,
        street:
          parseInt(this.formData.country.CountryId) == 5
            ? this.formData.addressLine
            : "",
        district: this.formData.district,
        countyState: this.formData.countyState,
        useDetails: parseInt(this.formData.country.CountryId) == 5,
        sourceSite: this.formData.webinarSource,
        referrerById: this.formData.referredBy,
        referralSourceId: this.formData.referralSource,
        referralEmployeeId: this.formData.referredByEmpId,
        gaTracking: decodeURIComponent(this.formData.gaTracking),
        bizId: this.formData.bizIdYOH,
      };

      //check for additional user
      if (this.formData.jointAccount == "yes") {
        payload.additionalUsers = [
          {
            titleId: parseInt(this.formData.titleAdditional),
            firstName: this.formData.firstNameAdditional,
            lastName: this.formData.lastNameAdditional,
            isEmailAddressSameAsMainApplicant:
              this.formData.emailAdditional == this.formData.email,
            email: this.formData.emailAdditional,
            dateOfBirth: this.formData.dobAdditional,
            isAddressSameAsMainApplicant: this.formData.sameAddressAsMain,
            buildingNameNo: this.formData.buildingNoAdditional,
            address:
              (this.formData.sameAddressAsMain &&
                parseInt(this.formData.country.CountryId) == 5) ||
              parseInt(this.formData.countryAdditional.CountryId) == 5
                ? ""
                : this.formData.addressLineAdditional,
            city: this.formData.cityAdditional,
            countryId: this.formData.sameAddressAsMain
              ? 0
              : parseInt(this.formData.countryAdditional.CRMCountryId),
            postcodeAnywhereId: this.formData.postcodeAnywhereIdAdditional,
            street:
              (this.formData.sameAddressAsMain &&
                parseInt(this.formData.country.CountryId) == 5) ||
              parseInt(this.formData.countryAdditional.CountryId) == 5
                ? this.formData.addressLineAdditional
                : "",
            district: this.formData.districtAdditional,
            countyState: this.formData.countyStateAdditional,
            useDetails:
              (this.formData.sameAddressAsMain &&
                parseInt(this.formData.country.CountryId) == 5) ||
              parseInt(this.formData.countryAdditional.CountryId) == 5,
            postcode: this.formData.postCodeAdditional,
          },
        ];
      }

      if (this.contactId) {
        payload.contactId = this.contactId;
        payload.mainContactId = this.mainContactId;
      }

      const { data } = this.contactId
        ? await axios.put(
            process.env.VUE_APP_API_URL + "/client/UpdateContact",
            payload,
            { headers: { Authorization: `Bearer ${this.jwtToken}` } }
          )
        : await axios.post(
            process.env.VUE_APP_API_URL + "/client/CreateContact",
            payload,
            { headers: { Authorization: `Bearer ${this.jwtToken}` } }
          );

      return data;
    },
    async createEnquiryOppurtunity(event, optIn) {
      //whent optIn always contactExist to true
      //set opportunitytypes
      let opportunitytypes = [];

      //jvpID is resolved server-side from eventId, so the value sent here is ignored
      opportunitytypes.push({
        oppTypeID: 19,
        jvpID: 0,
      });
      if (!optIn) { //if optin we don't need to pass opportunity types
        this.formData.opportunityTypes.forEach((ot) => {
          if (ot.Selected) {
            opportunitytypes.push({ oppTypeID: ot.ServicesTypeId, jvpID: 0 });
          }
        });
      }
      const payload = {
        IsContactExist: optIn ? true : this.formData.isContactExist,
        name: this.formData.firstName + "," + this.formData.lastName,
        contactId: this.contactId,
        bizID: this.formData.bizIdYOH,
        countryId: parseInt(this.formData.countryBuyingIn.CRMCountryId),
        eventId: event.id,
        phone: this.formData.mobilePrefix + this.formData.mobile,
        referralSource: this.formData.referralSource,
        remarks: decodeURIComponent(this.formData.gaTracking),
        sourceSite: event.sourceSite + this.formData.sourceSiteToAppend,
        region:
          this.formData.regionId != ""
            ? this.formData.regionId.toString()
            : this.formData.region,
        budgetID: parseInt(this.formData.propertyBudget),
        timescaleID: parseInt(this.formData.timescale),
        funding: this.formData.funding.toString(),
        hasTripPlanned: this.formData.tripPlannedOn != null,
        tripPlannedOn: this.formData.tripPlannedOn,
        multiOpportunityTypeIDs: opportunitytypes,
        referrerById: this.formData.referredBy,
        referralEmployeeId: this.formData.referredByEmpId,
      };

      await axios.post(
        process.env.VUE_APP_API_URL + "/client/CreateYOHEnquiry",
        payload,
        { headers: { Authorization: `Bearer ${this.jwtToken}` } }
      );
    },
    logApi(payload) {
      try {
        axios.post(process.env.VUE_APP_API_URL + "/Log/SaveLogs", payload);
      } catch (ex) {
        console.log(ex);
      }
    },
    async sendCodeToMobile(contactId) {
      try {
        const { data } = await axios.post(
          process.env.VUE_APP_API_URL + "/client/GenerateAndSend2FA",
          { contactId: contactId },
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.getJwtToken}`,
            },
          }
        );
        if (data != null) {
          if (
            process.env.VUE_APP_API_URL.indexOf("onboardingapidev") > -1 &&
            data.indexOf("Code:") > -1
          ) {
            this.$store.dispatch(
              "setTwofaMessage",
              "On-screen " + data.substr(data.indexOf("Code:"))
            );
          }
        }
        return data;
      } catch (ex) {
        console.log(ex);
      }
    },
    async doGBGChecks() {
      await this.gbgVerification();
    },
    async gbgVerification() {
      try {
        //check main user first
        const resMain = await axios.post(
          process.env.VUE_APP_API_URL + "/client/GBGVerification",
          {
            contactId: this.contactId,
            mainContactId: this.mainContactId,
            sourceSite: this.formData.sourceSite,
            isAdditionalUser: this.additionalContactId != null,
          },
          { headers: { Authorization: `Bearer ${this.jwtToken}` } }
        );

        this.$store.dispatch(
          "setMainUserGBGStatus",
          resMain.data.data.verificationstatus.toLowerCase()
        );

        //gbg check for sub user?
        if (this.additionalContactId != null) {
          const resSub = await axios.post(
            process.env.VUE_APP_API_URL + "/client/GBGVerification",
            {
              contactId: this.additionalContactId,
              mainContactId: this.mainContactId,
              sourceSite: this.formData.sourceSite,
              isAdditionalUser: false,
            },
            { headers: { Authorization: `Bearer ${this.jwtToken}` } }
          );

          this.$store.dispatch(
            "setAdditionalUserGBGStatus",
            resSub.data.data.verificationstatus.toLowerCase()
          );
        }
      } catch (ex) {
        console.log(ex);
      }
    },
    async createGBGLink(contactId,journeyType) {
      try{
      const { data } = await axios.post(
        process.env.VUE_APP_API_URL + `/client/CreateGBGLink?contactId=${contactId}&journeyType=${journeyType}`,
        null,
        { headers: { Authorization: `Bearer ${this.jwtToken}` } }

      );
      return data.data;
      }catch(ex){
        console.log(ex)
      }
    },
    async getIDCheckStatus(sessionId) {
      try{
      const { data } = await axios.get(
        process.env.VUE_APP_API_URL + `/client/GetIDCheckStatus?sessionId=${sessionId}`);
      return data.data;
      }catch(ex){
        console.log(ex)
      }
    },
  },
};
